import { Link } from 'react-router-dom';
import { recommendedComics } from '@/mocks/comics';
import { ComicCard } from './ComicCard';

export function FeaturedSection() {
  return (
    <section className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-20">
      <div className="flex items-center justify-between mb-6">
        <div>
          <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-accent-100 text-accent-700 mb-3">
            编辑精选
          </span>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            精选
            <span className="text-accent-500">推荐</span>
          </h2>
        </div>
        <Link
          to="/category/romance"
          className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1 whitespace-nowrap"
        >
          查看更多 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
        {recommendedComics.slice(0, 6).map((comic) => (
          <ComicCard key={comic.id} comic={comic} />
        ))}
      </div>
    </section>
  );
}